import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩国漫画`}
          title={`${comic.title} - 韩漫在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {comic.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
            热门
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
            新作
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <span className="text-xs text-white/90 whitespace-nowrap">{comic.status}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-xs text-accent-500"></i>
            </div>
            <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
          </div>
          <span className="text-xs text-foreground-400">
            {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}